// keyrd_console/src/api/headers.js

/**
 * Build canonical KeyRD request headers.
 *
 * Supported options:
 *   - token            → Bearer token
 *   - registryVersion  → X-KeyRD-Registry-Version
 *   - registryHash     → X-KeyRD-Registry-Hash
 *   - contentType      → Content-Type
 *   - extra            → additional headers (object)
 */
export function buildKeyrdHeaders(opts = {}) {
  const {
    token,
    registryVersion,
    registryHash,
    contentType,
    extra,
  } = opts;

  const headers = {};

  if (contentType) headers["Content-Type"] = contentType;
  if (registryVersion) headers["X-KeyRD-Registry-Version"] = registryVersion;
  if (registryHash) headers["X-KeyRD-Registry-Hash"] = registryHash;
  if (token) headers["Authorization"] = `Bearer ${token}`;

  if (extra && typeof extra === "object" && !Array.isArray(extra)) {
    Object.assign(headers, extra);
  }

  return headers;
}
